<template>
    <div>

        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>背调列表</b></p>

            <div style="display:inline-block;width: 300px;">
                <el-input placeholder="请输入姓名/身份证号码" v-model="queryValue" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="searchOrder"></el-button>
                </el-input>
            </div>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 10px;color:coral;">
                剩余查询次数：<span style="color:black;">{{ surveyCount }}</span>
            </p>

            <!-- <p style="display:inline;float: right;line-height: 40px;margin:5px 0;">
                <el-button round @click="exportExcel">导出</el-button>
                <span>-</span>
            </p> -->

            <!-- <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                <el-button round @click="download">下载模板</el-button>
                <span>-</span>
            </p> -->

            <!-- <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                <el-upload action="#" :http-request="uploadFile" :show-file-list="false">
                    <el-button round type="primary">批量导入</el-button>
                    <span>-</span>
                </el-upload>
            </p> -->

        </div>

        <el-table :data="orderList" style="width: 2000px;" ref="plasticTable" highlight-current-row v-loading="loading"
            element-loading-text="加载中" @selection-change="handleSelectionChange">

            <el-table-column type="selection" width="45">
            </el-table-column>

            <el-table-column prop="bigName" label="刺头" min-width="10%">
            </el-table-column>

            <el-table-column prop="identityCard" label="身份证号" min-width="20%">
            </el-table-column>

            <el-table-column prop="disputesImage" label="纠纷证明" min-width="10%">
                <template slot-scope="scope">
                    <el-image :src="'https://' + imagePath + scope.row.disputesImage"
                        v-if="scope.row.disputesImage == '' ? false : true"></el-image>
                </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注" min-width="20%">
            </el-table-column>

        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes, prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[6, 10, 14, 18]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

    </div>
</template>

<script>
export default {
    name: "SurveyOrder",
    data() {
        return {
            token: this.getToken(),
            imagePath:this.getImagePath(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),

            surveyCount: 0,
            orderList: [],
            dlgFormVisible: false,

            queryValue: '',

            loading: false,
            modifyDisable: false,

            formLabelWidth: '120px',

            multipleSelection: [],

            pageIndex: 0,
            pageNum: 6,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        // handleSelectionChange(val) {
        //     // console.log('val')
        //     // console.log(val)
        //     this.multipleSelection = val
        // },
        getCount() {
            this.$axios({
                method: "post",
                url: "/shiro/company/get",
                data: {
                    id: this.companyId,
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.surveyCount = data.data.queryCount
            })
        },
        searchOrder(query) {

            this.orderList = []
            this.pageIndex = 0

            if (this.queryValue !== '') {

                this.loading = true

                setTimeout(() => {

                    this.getAllOrder()
                }, 200)

            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        handleClick(row) {

            this.modifyDisable = true
            // console.log(row);
            this.form.id = row.id

            this.dlgFormVisible = true

        },
        getAllOrder() {

            const formData = new FormData()

            formData.append('userId', this.userId)

            formData.append('queryParam', this.queryValue)

            formData.append('companyId', this.companyId)
            formData.append('pageIndex', this.pageIndex)
            formData.append('pageNum', this.pageNum)

            this.$axios({
                method: "post",
                url: "/shiro/survey/order/get",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    this.loading = false
                    return
                }

                this.orderList = data.data

                this.total = this.orderList.length > 0 ? this.orderList[0].total : 0

                // for (let i in this.orderList) {

                //     this.orderList[i].createdTime = this.$moment(this.orderList[i].createdTime).format("YYYY-MM-DD")

                // }

                this.loading = false

                this.getCount()
            })
        }
    },
    mounted() {

        console.log('SurveyOrder.vue--mounted()')

        this.setDefaultPath('/surveyOrder')

        this.getCount()
    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

/* .DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
} */

.el-pagination__total {
    color: green;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
}

.el-radio input[aria-hidden="true"] {
    display: none !important;
}

.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
}
</style>